import React from 'react';
import '../css/banner.css'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Bannerfirst from '../images/banner1.jpg';
import Bannersecond from '../images/banner2.jpg';
import Bannerthird from '../images/banner3.jpg';
import Bannerforth from '../images/banner4.jpg';
import Bannerfifth from '../images/banner5.jpg';
import Bannersixth from '../images/banner6.jpg';
import Bannerseventh from '../images/banner7.jpg';
import Bannereighth from '../images/banner8.jpg';

function Banner(){
    const settings = {
        dots: true,
        infinite: true,
        arrow:true,
        autoplay: true,
        speed: 900,
        slidesToShow: 1,
        slidesToScroll: 1
      };

    return(
        <div className="banner">
            <div className="banner-container">
            <Slider {...settings}>
                <div>
                    <img src={Bannerfirst} alt="im" />
                </div>
                <div>
                <img src={Bannersecond} alt="im" />
                </div>
                <div>
                <img src={Bannerthird} alt="im" />
                </div>
                <div>
                <img src={Bannerforth} alt="im" />
                </div>
                <div>
                <img src={Bannerfifth} alt="im" />
                </div>
                <div>
                <img src={Bannersixth} alt="im" />
                </div>
                <div>
                <img src={Bannerseventh} alt="im" />
                </div>
                <div>
                <img src={Bannereighth} alt="im" />
                </div>
                </Slider>
            </div>
        </div>
    )
}

export default Banner;